var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4995 2.96918V14.0909H14.5917V0H17.5305C17.9204 0 18.3065 0.0768063 18.6667 0.226021C19.0269 0.375237 19.3542 0.593945 19.6299 0.869657C19.9056 1.14537 20.1243 1.47269 20.2735 1.83292C20.4227 2.19316 20.4995 2.57927 20.4995 2.96918Z",
    fill: "url(#paint0_linear_11103_86624)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.592 4.4257e-07V5.90825H0.499878V2.96918C0.499969 2.57909 0.576904 2.19285 0.726285 1.8325C0.875666 1.47215 1.09457 1.14477 1.37049 0.869043C1.64641 0.593317 1.97394 0.374651 2.33437 0.225541C2.69481 0.0764299 3.08108 -0.000212514 3.47115 4.4257e-07H14.592Z",
    fill: "url(#paint1_linear_11103_86624)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40768 5.9082V19.9991H3.47115C3.08108 19.9993 2.69479 19.9227 2.33434 19.7736C1.97389 19.6245 1.64634 19.4058 1.37042 19.1301C1.09449 18.8544 0.875592 18.527 0.726222 18.1666C0.576851 17.8062 0.499939 17.42 0.499878 17.0299V5.9082H6.40768Z",
    fill: "url(#paint2_linear_11103_86624)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5002 14.0908V17.0308C20.5002 17.4207 20.4234 17.8068 20.2742 18.1671C20.125 18.5273 19.9063 18.8546 19.6306 19.1303C19.3549 19.406 19.0276 19.6247 18.6674 19.774C18.3072 19.9232 17.9211 20 17.5312 20H6.40808V14.0917L20.5002 14.0908Z",
    fill: "url(#paint3_linear_11103_86624)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4995 9.69336V14.0915H14.5917V12.8626L20.4995 9.69336Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7573 19.9991H6.40808V14.0908H7.58915L10.7573 19.9991Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40768 5.9082V7.14497L0.499878 10.3133V5.9082H6.40768Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.637 0V6.59612H14.593V5.90825H13.3887L10.2206 0H14.637Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4995 13.9335V14.091H14.5917V13.8686L16.0298 13.8594L17.5189 13.8686L19.0104 13.8918L20.4995 13.9335Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63967 15.4133L6.63041 16.9419L6.60261 18.4705L6.55627 19.9991H6.40808V14.0908H6.63272L6.63967 15.4133Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40768 5.9082V6.13286L5.02742 6.13749L3.51978 6.12823C2.51238 6.11433 1.50728 6.09349 0.499878 6.05411V5.9082H6.40768Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5914 0V5.90825H14.4108L14.4061 4.65063L14.4131 3.10119C14.4293 2.06592 14.4501 1.03296 14.4895 0H14.5914Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4994 14.0908V17.0308C20.46 16.5421 20.4299 16.0511 20.4068 15.5624C20.3813 15.1247 20.3651 14.6893 20.3489 14.2539L19.0103 14.2909L17.5189 14.3141L16.0298 14.3234L14.5407 14.3141L13.0516 14.2909L11.5601 14.2516C10.5689 14.2122 9.57542 14.1705 8.58191 14.0917L20.4994 14.0908Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40703 7.76855V19.9996H3.65808C4.52422 19.9325 5.38804 19.8908 6.25418 19.8584L6.21249 18.471L6.1847 16.9425L6.17544 15.4138L6.18239 13.8852C6.1847 13.3757 6.1986 12.8662 6.20555 12.3567C6.21249 11.8471 6.23334 11.3376 6.24723 10.8258C6.28429 9.8067 6.32829 8.78762 6.40703 7.76855Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5749 5.90902H0.499878V3.29883C0.564722 4.11871 0.60641 4.93859 0.638832 5.75848C1.59761 5.72373 2.55869 5.70289 3.51978 5.68899L5.02742 5.67973L6.53737 5.68436C7.54477 5.69363 8.55142 5.71447 9.55727 5.74689C10.5624 5.78627 11.5698 5.82796 12.5749 5.90902Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9974 0.0833816C15.5945 0.108858 15.1915 0.12507 14.7862 0.141283C14.8233 1.12792 14.8418 2.11456 14.858 3.10119L14.8649 4.65063L14.8603 6.20007C14.8511 7.23303 14.8302 8.26675 14.7978 9.30126C14.7769 9.81774 14.7631 10.3342 14.7306 10.8507C14.6982 11.3672 14.6774 11.8837 14.6357 12.4001C14.6172 12.1801 14.6033 11.9601 14.5917 11.7401V0H17.3615C16.9078 0.0370568 16.4516 0.057905 15.9974 0.0833816Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11103_86624",
    x1: 17.5456,
    y1: -0.239545,
    x2: 17.5456,
    y2: 14.0345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285F4",
    stopOpacity: 0.43
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11103_86624",
    x1: 14.5074,
    y1: 2.95412,
    x2: 0.866273,
    y2: 2.95412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    stopColor: "#F81000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#F93F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    stopColor: "#FA6800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    stopColor: "#FA8900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#FBA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693,
    stopColor: "#FBB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#FBC000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11103_86624",
    x1: 3.45378,
    y1: 19.3932,
    x2: 3.45378,
    y2: 6.17594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3398F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2660A5",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11103_86624",
    x1: 6.40808,
    y1: 17.0454,
    x2: 20.5002,
    y2: 17.0454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    stopColor: "#F81000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#F93F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    stopColor: "#FA6800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    stopColor: "#FA8900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#FBA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693,
    stopColor: "#FBB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#FBC000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7900"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.f54c89398f060bfa1f83794f756ab474.svg";
export { ForwardRef as ReactComponent };